export default {
  primary: '#02884E',
  primaryDark: '#006D3E',
  darkBg: '#22253F',
  white: '#FFFFFF',
  dark: '#373B49',
  dark1: '#717688',
  dark2: '#9AA0B3',
  dark3: '#E5E7EF',
  dark4: '#F2F3F7',
  gray: '#F3F3F3',
  red: '#C80000',
  redMinus10: '#F9E6E6',
  greenMinus10: '#E6F3ED',
  boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.05)',
  underlineShadow: '0px 1px 0px rgba(154, 160, 179, 0.25)',
  secondaryYellow: '#F2D600',
  darkYellow: '#C99957',
  yellowMinus10: '#FEFBE6',
  secondaryRed: '#EB5A46',
  secondaryRedMinus10: '#FDEFED',
  secondaryBlue: '#0087FF',
  blueMinus10: '#E6F3FF',
  secondaryOrange: '#FF9F19',
  orangeMinus10: '#FFF5E8',
  secondaryLightGreen: '#50E898',
  lightGreenMinus10: '#EEFDF5',
  secondaryCyan: '#0279BF',
  cyanMinus10: '#E6F2F9',
  secondaryGreenMedium: '#60BD4F',
  greenMediumMinus10: '#EFF8ED',
  secondaryPurple: '#C376E0',
  purpleMinus10: '#F9F1FC',
  darkPurple: '#840163',
  darkBlue: '#2B5799',
  darkRed: '#DC1E00'
}
